<template>
  <div class="home">
    <h2 class="title">线索反映（工程建设领域）</h2>
    <van-form
      label-width="4rem"
      error-message-align="right"
      input-align="right"
      @submit="onSubmit"
      ref="forms"
    >
      <van-field
        v-model="form.projectName"
        name="拖欠工资项目名称"
        placeholder="请输入项目名称"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          拖欠工资项目名称
        </template>
      </van-field>

      <van-field
        v-model="form.arrearsUnitName"
        name="欠薪单位名称"
        placeholder="请输入欠薪单位名称"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          欠薪单位名称
        </template>
      </van-field>

      <van-field
        readonly
        clickable
        v-model="form.projectAreaName"
        name="实际用工所在地"
        right-icon="arrow"
        placeholder="请选择"
        :rules="[{ required: true, message: '' }]"
        @click="areaShow = true"
      >
        <template #label>
          <span class="ts">*</span>
          实际用工所在地
        </template>
      </van-field>

      <van-field
        v-model="form.reflectName"
        name="反映人姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          反映人姓名
        </template>
      </van-field>
      <van-field
        v-model="form.reflectTel"
        name="反映人电话"
        placeholder="请输入电话"
        :rules="[
          { required: true, message: '' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' }
        ]"
      >
        <template #label>
          <span class="ts">*</span>
          反映人电话
        </template>
      </van-field>

      <van-field
        v-model="form.reflectIdcard"
        name="反映人身份证号"
        placeholder="请输入身份证号"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          反映人身份证号
        </template>
      </van-field>

      <van-field
        v-model="form.backPayPerson"
        name="欠薪人数(单位:人)"
        placeholder="请输入人数"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          欠薪人数(单位:人)
        </template>
      </van-field>
      <van-field
        v-model="form.backPayMoney"
        name="欠薪金额(单位:元)"
        placeholder="请输入金额"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          欠薪金额(单位:元)
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        v-model="backPayDate"
        name="欠薪发生时间"
        placeholder="请选择日期"
        right-icon="arrow"
        @click="calenderShow = true"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          欠薪发生时间
        </template>
      </van-field>
      <van-field
        class="texts"
        v-model="form.backPaySummary"
        rows="3"
        type="textarea"
        autosize
        name="backPaySummary"
        placeholder="(请将欠薪过程描述清楚，并控制在500字以内)"
        maxlength="500"
        show-word-limit
        :rules="[{ required: true, message: '' }]"
        input-align="left"
      >
        <template #label>
          <span class="ts">*</span>
          欠薪基本情况摘要
        </template>
      </van-field>

      <van-field
        label-width="8rem"
        class="radios"
        :rules="[{ required: true, message: '' }]"
      >
        <template #label>
          <span class="ts">*</span>
          是否曾经通过以下途径反应过上述欠薪问题
        </template>
        <template #input>
          <van-radio-group
            class="radioAll"
            v-model="form.reflectChannel"
            @change="radioFn()"
          >
            <van-radio
              name="向劳动保障监察机构举报，投诉"
              checked-color="#4967B7"
              >向劳动保障监察机构举报，投诉</van-radio
            >
            <van-radio
              name="向劳动人事争议仲裁部门申请仲裁"
              checked-color="#4967B7"
              >向劳动人事争议仲裁部门申请仲裁</van-radio
            >
            <van-radio name="向人民法院提起诉讼" checked-color="#4967B7"
              >向人民法院提起诉讼</van-radio
            >
            <van-radio name="其他途径" checked-color="#4967B7"
              >其他途径</van-radio
            >
            <van-radio
              name="未曾经通过以上反映过欠薪问题"
              checked-color="#4967B7"
              >未曾经通过以上反映过欠薪问题</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        v-if="form.reflectChannel != '未曾经通过以上反映过欠薪问题'"
        class="texts"
        v-model="form.reflectDetail"
        rows="3"
        type="textarea"
        autosize
        name=""
        placeholder="(请将情况描述清楚，并控制在200字以内)"
        maxlength="200"
        show-word-limit
        :rules="[{ required: true, message: '' }]"
        input-align="left"
      >
        <template #label>
          <span class="ts">*</span>
          详细说明情况
        </template>
      </van-field>
      <!-- 验证码 -->
      <tel-code ref="telCode"></tel-code>
      <div class="info">
        （注：带“*”为必填项）
      </div>

      <!-- 用户服务协议/隐私政策 -->
      <div class="useragent_file">
        <van-checkbox
          checked-color="#4967B7"
          v-model="checked"
          shape="square"
          label-disabled
        >
          我已阅读并同意
          <span @click="showAgentDialog('1')">《用户服务协议》</span>和
          <span @click="showAgentDialog('2')">《隐私政策》</span>
        </van-checkbox>
      </div>

      <div class="btns">
        <van-button
          color="#4967B7"
          class="submitBtn"
          type="info"
          native-type="submit"
          :disabled="!checked"
          >提交</van-button
        >
        <van-button
          color="#4967B7"
          plain
          class="resetBtn"
          @click="resetFn()"
          native-type="button"
          >重置</van-button
        >
      </div>
    </van-form>
    <!-- 市 -->
    <van-popup v-model="areaShow" round position="bottom">
      <van-cascader
        v-model="form.projectAreaCode"
        title="请选择实际用工所在地"
        active-color="#4967B7"
        :options="areaList"
        @close="areaShow = false"
        @finish="onFinish"
        :field-names="{
          text: 'bladeRegionName',
          value: 'bladeRegionCode',
          children: 'childrenList'
        }"
      />
    </van-popup>

    <!-- 文件协议 -->
    <van-dialog
      v-model="show"
      :title="way === '1' ? '用户服务协议' : '隐私政策'"
      confirmButtonText="我已阅读并知晓"
      confirmButtonColor="#4967b7"
      class="yantai-dialog"
      :show-confirm-button="true"
      :show-cancel-button="false"
    >
      <div ref="dialogContent">
        <div class="dialog_content" v-show="way === '1'">
          <p>《用户服务协议》</p>
          <p>更新日期：2026年9月3日</p>
          <p>生效日期：2026年9月3日</p>

          <p class="mt16 mb16">
            欢迎您使用“山东欠薪维权-码上安薪”小程序（以下简称“本小程序”）。本小程序由山东省劳动人事争议仲裁院主办并运营，由北京晟邦知享科技发展有限公司提供技术支持与相关网络服务（以下统称“我们”）。在您使用本小程序提供的线索反映及相关服务之前，请务必仔细阅读并充分理解本《用户服务协议》（以下简称“本协议”）。
          </p>

          <p>一、协议的接受与修改</p>
          <p>
            当您进入、浏览、使用本小程序，或在提交表单前勾选“同意”本协议时，即表示您已充分阅读、理解并接受本协议的全部内容。我们有权根据相关法律法规要求或业务调整需要适时修改本协议。修改后的协议将在本小程序内公布，一经公布即替代原协议生效。
          </p>

          <p class="mt16">二、服务内容与用户使用规范</p>
          <p>
            服务内容：
            本小程序主要为用户提供工程建设领域及非工程建设领域的欠薪线索登记、反映及维权协助服务。
          </p>

          <p class="mt16">信息填写真实性保障：</p>
          <p>
            您在工程建设领域线索反映中填写的拖欠工资项目名称、欠薪单位名称、实际用工所在地、反映人姓名、联系电话、身份证号、欠薪人数、欠薪金额、欠薪发生时间及基本情况摘要等信息，必须真实、客观、有效。
          </p>
          <p>
            您在非工程建设领域线索反映中填写的反映人姓名、身份证号、联系电话、住所、实际用工所在地、欠薪人数、欠薪金额、欠薪发生时间、欠薪基本情况摘要、以往反映途径，以及被反映单位名称、办公场所、联系人/负责人、联系电话、短信验证码等信息，必须真实、客观、有效。
          </p>
          <p>
            严禁恶意虚构事实、冒用他人身份、伪造证据或进行恶意检举、诬告陷害。
          </p>
          <p>
            禁止行为：
            您不得利用本服务传输或发布违反国家法律法规、侵犯他人合法权益、危害国家安全或破坏社会稳定的信息。
          </p>

          <p class="mt16">三、个人信息保护</p>
          <p>
            我们高度重视您的个人信息安全，将严格按照《中华人民共和国个人信息保护法》及相关法律法规，制定并实施《隐私政策》。您在提交表单时填写的个人信息及相关线索，将严格按照隐私政策约定的范围进行收集与使用。
          </p>

          <p class="mt16">四、免责声明</p>
          <p>
            本小程序作为欠薪线索反映与维权信息采集平台，对用户自行填写的线索及材料的真实性不承担保证或担保责任。
          </p>
          <p>
            因不可抗力、网络中断、计算机病毒、黑客攻击或系统升级维护等原因导致的服务暂停、延误或数据丢失，我们将尽力修复，但在法律法规允许的范围内免除相应责任。
          </p>
        </div>

        <div class="dialog_content" v-show="way === '2'">
          <p>《隐私政策》</p>
          <p>更新日期：2026年9月3日</p>
          <p>生效日期：2026年9月3日</p>

          <p class="mt16">
            山东省劳动人事争议仲裁院（主体单位）与北京晟邦知享科技发展有限公司（技术及网络服务提供方，以下统称“我们”）作为“山东欠薪维权-码上安薪”小程序（以下简称“本小程序”）的运营及服务提供方，高度重视用户的隐私和个人信息保护。本《隐私政策》将明确告知您我们在您使用本小程序进行线索反映时，如何收集、使用、存储及保护您的个人信息。
          </p>

          <p>一、我们如何收集和使用您的个人信息</p>
          <p>
            为了向您提供欠薪线索登记、核实、转办及维权协助服务，基于合法、正当、必要的原则，我们需要收集您的以下个人信息：
          </p>
          <p>反映人身份及联系信息（必要信息）：</p>
          <p>
            收集字段：姓名、身份证号、联系电话、住所、手机短信验证码。使用目的：用于核实反映人真实身份，通过验证码确保本人操作，并用于后续工作人员向您反馈欠薪线索的处理进度与结果。
          </p>

          <p class="mt16">工程建设领域线索信息：</p>
          <p>
            收集字段：
            拖欠工资项目名称、欠薪单位名称、实际用工所在地、欠薪人数、欠薪金额、欠薪发生时间、欠薪基本情况摘要。
          </p>
          <p>
            使用目的： 用于精准定位工程项目及责任主体，核实欠薪事实与诉求规模。
          </p>

          <p class="mt16">非工程建设领域线索信息：</p>
          <p>
            收集字段：
            实际用工所在地、欠薪人数、欠薪金额、欠薪发生时间、欠薪基本情况摘要、以往反映途径（如是否向劳动监察、仲裁、法院等反映过）。
          </p>
          <p>
            使用目的：
            用于研判欠薪事实及前期维权处置情况，制定相应的转办或协调方案。
          </p>
          <p>被反映单位（涉嫌欠薪方）信息：</p>
          <p>
            收集字段： 被反映单位名称、办公场所、联系人/负责人姓名、联系电话。
          </p>
          <p>
            使用目的：
            用于相关监管部门或工作组依法与被反映单位取得联系，开展线索核查、调查及沟通协调。
          </p>

          <p class="mt16">设备与日志信息：</p>
          <p>
            为保障系统安全稳定运行及防范恶意重复提交，微信平台及本小程序可能会收集必要的设备标识与操作日志信息。
          </p>

          <p class="mt16">二、信息收集的授权与同意</p>
          <p>
            在您首次提交欠薪线索表单时，我们将通过勾选框或弹窗方式向您明确告知，并取得您的明确授权同意后，才会正式收集并提交上述信息。如您拒绝提供上述必要信息，您将无法通过本小程序在线提交欠薪线索，但仍可浏览小程序内的公开指南或公示信息。
          </p>

          <p class="mt16">三、我们如何存储与保护您的个人信息</p>
          <p>
            存储期限：
            我们仅在实现欠薪线索处理及维权服务目的所必需的最短期限内保留您的个人信息，达到保留期限或处理完毕后，我们将依法进行删除或匿名化处理。
          </p>
          <p class="mt16">
            安全措施：
            我们采用符合行业安全标准的技术措施（包括数据加密传输、加密存储及严格的后台访问权限控制）保护您的个人信息，防止数据遭到未经授权的访问、泄露、篡改或毁损。
          </p>

          <p class="mt16">四、信息的共享与披露</p>
          <p>
            未经您的明确授权，我们不会将您的个人信息共享或转让给任何无关的第三方机构或公司。
          </p>
          <p>
            特定处理流程：为依法推进欠薪线索的查处与解决，您提交的线索及个人信息将被依法转交或对接至有管辖权的劳动保障监察机构、劳动人事争议仲裁部门、住房城乡建设等行业主管部门或相关司法机关。
          </p>

          <p class="mt16">五、您的权利</p>
          <p>
            按照相关法律法规，您对自己的个人信息享有查询、更正、删除及撤回授权同意等合法权利。我们将在符合法律规定的范围内，保障您的上述权益。
          </p>

          <p class="mt16">六、主体及技术支持说明</p>
          <p>
            主办/运营主体： 山东省劳动人事争议仲裁院
          </p>
          <p>
            技术支持/网络服务单位： 北京晟邦知享科技发展有限公司
          </p>
        </div>
      </div>
    </van-dialog>

    <van-calendar
      color="#4967B7"
      v-model="calenderShow"
      :min-date="new Date(2017, 1, 1)"
      @confirm="onDateConfirm"
    />
  </div>
</template>

<script>
import { getSm2Key } from "@/http";

let form = {
  projectId: "", //选填 项目id
  projectName: "", //必填	项目名称
  arrearsUnitName: "", //必填	欠薪单位名称
  projectAreaCode: "", //必填	项目所在市： 济南市 青岛市 地域编码
  projectAreaName: "", //必填	项目所在市： 济南市 青岛市 地域名称

  projectCityCode: "", //必填	项目所在区： 历下区 历城区 地域编码
  projectCityName: "", //必填	项目所在区： 历下区 历城区 地域名称

  reflectName: "", //必填	反馈人名称
  reflectTel: "", //必填	反馈人电话
  reflectIdcard: "", //必填	反馈人身份证号码
  backPayPerson: "", //必填	欠薪人数
  backPayMoney: "", //必填	欠薪金额
  backPayDate: "", //必填	反映日期
  backPaySummary: "", //必填	欠薪情况摘要

  reflectChannel: "未曾经通过以上反映过欠薪问题", //必填	反馈途径，传文字
  reflectDetail: "" //必填	反馈详情
};
import TelCode from "@/components/TelCode.vue";
import { rsaPublicData, validateIdCard } from "./util";
import router from "../router";
export default {
  name: "Home",
  components: {
    TelCode
  },
  data() {
    return {
      areaShow: false, //市
      areaList: [], //市列表

      calenderShow: false, //日期模态框

      backPayDate: "", // 起始日期模态框
      form: JSON.parse(JSON.stringify(form)),
      sourceType: "",

      checked: false,
      show: false,
      way: "1" // 1-用户服务协议 2-隐私协议
    };
  },
  methods: {
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.form.projectAreaName = selectedOptions
        .map(option => option.bladeRegionName)
        .join("-");
      this.areaShow = false;
    },
    //日期
    formatDate(date, d1) {
      let s = `${date.getFullYear()}年${date.getMonth() +
        1}月${date.getDate()}日`;
      if (d1 == "-") {
        s = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      }
      return s;
    },
    //
    radioFn() {},
    onDateConfirm(date) {
      this.calenderShow = false;
      this.backPayDate = this.formatDate(date, "");
      this.form.backPayDate = this.formatDate(date, "-");
    },
    //验证途径选项，提交前调用
    isRefiect() {
      if (this.form.reflectChannel == "未曾经通过以上反映过欠薪问题") {
        this.form.reflectDetail = "";
      }
    },

    // 提交
    onSubmit(values) {
      // if (!this.checked) {

      // }
      if (this.form.reflectIdcard) {
        if (!validateIdCard(this.form.reflectIdcard)) {
          this.$toast.fail("身份证号格式错误！");
          return false;
        }
      }
      if (this.form.backPayPerson) {
        let reg = /^[1-9]\d*$/;
        if (!reg.test(this.form.backPayPerson)) {
          this.$toast.fail("欠薪人数格式错误,请输入正整数！");
          return false;
        }
      }
      if (this.form.backPayMoney) {
        let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
        if (!reg.test(this.form.backPayMoney)) {
          this.$toast.fail("欠薪金额格式错误,例如'100'！");
          return false;
        }
      }
      this.isRefiect();
      this.$http
        .submit({
          ...this.form,
          reflectTel: rsaPublicData(this.form.reflectTel),
          reflectIdcard: rsaPublicData(this.form.reflectIdcard),
          reflectName: rsaPublicData(this.form.reflectName),
          isConstruction: 1,
          phone: rsaPublicData(this.form.reflectTel),
          smsCode: rsaPublicData(this.$refs.telCode.telCode),
          projectAreaCode: this.form.projectAreaCode,
          projectAreaName: this.form.projectAreaName,
          sourceType: this.sourceType || "1"
        })
        .then(res => {
          if (res.result) {
            this.resetFn();
            this.$router.push({
              path: "/submitSuccess",
              query: { ...this.$route.query }
            });
          } else {
            this.$toast.fail(res.errorMsg);
          }
        });
    },
    resetFn() {
      this.form = JSON.parse(JSON.stringify(form));
      this.backPayDate = "";
      this.$refs.telCode.telCode = "";
      // this.$refs.telCode.count = 2
      // this.form.backPaySummary = ""
      this.$refs.forms.resetValidation();
      // location.reload();
    },
    getAreaList() {
      return new Promise((resolve, reject) => {
        this.$http.getArea({}).then(res => {
          this.areaList = (res[0]?.childrenList ?? [])?.map(item => {
            return {
              ...item,
              childrenList: item.childrenList.filter(
                childrenitem =>
                  childrenitem?.bladeRegionCode !==
                    `${item?.bladeRegionCode}01` &&
                  childrenitem.bladeRegionCode !== "370184" &&
                  childrenitem.bladeRegionCode !== "371340" &&
                  childrenitem.bladeRegionCode !== "371343" &&
                  childrenitem.bladeRegionCode !== "371344" &&
                  childrenitem.bladeRegionCode !== "370297" &&
                  childrenitem.bladeRegionCode !== "370291" &&
                  childrenitem.bladeRegionCode !== "370292" &&
                  childrenitem.bladeRegionCode !== "370293" &&
                  childrenitem.bladeRegionCode !== "370294" &&
                  childrenitem.bladeRegionCode !== "370295" &&
                  childrenitem.bladeRegionCode !== "370296" &&
                  childrenitem.bladeRegionCode !== "370298" &&
                  childrenitem.bladeRegionCode !== "370299" &&
                  childrenitem.bladeRegionCode !== "370710" &&
                  childrenitem.bladeRegionCode !== "370985" &&
                  childrenitem.bladeRegionCode !== "370906" &&
                  childrenitem.bladeRegionCode !== "371771" &&
                  childrenitem.bladeRegionCode !== "371704" &&
                  childrenitem.bladeRegionCode !== "370290"
              )
            };
          });
          this.areaList = this.areaList.filter(
            item => item?.bladeRegionCode !== "3718"
          );
          resolve();
        });
        //reject();
      });
    },
    getPublicKey() {
      this.$http.getSm2Key({}).then(res => {
        if (res) {
          sessionStorage.setItem("2KCG", res.toString());
        }
      });
    },

    showAgentDialog(way) {
      this.way = way;
      this.show = true;
      this.$nextTick(() => {
        const scrollEl = document.querySelector(
          ".yantai-dialog .van-dialog__content"
        );
        if (scrollEl) {
          scrollEl.scrollTop = 0;
        }
      });
    }
  },
  created() {
    //获取市和区
    this.getAreaList();
    this.getPublicKey();
  },
  mounted() {
    let source = this.$route.fullPath.split("?")[1];
    if (source) {
      if (source.includes("sourceType")) {
        this.sourceType = source.split("=")[1];
      } else if (source.includes("aishandong")) {
        this.sourceType = "4";
      } else if (source.includes("wechatminiapp")) {
        this.sourceType = "8";
      } else if (source.includes("wechat")) {
        this.sourceType = "5";
      } else if (source.includes("msg")) {
        this.sourceType = "7";
      } else {
        this.sourceType = "1";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  padding: 10px;
  * {
    // border: 1px solid #ccc;
  }
  .title {
    font-size: 20px;
    text-align: center;
    color: #4967b7;
    font-weight: 400;
    line-height: 50px;
  }
  .van-cell {
    background-color: #f1f1f1;
    // padding: 10px;
    margin: 10px 0;
    // width: auto;
    border-radius: 5px;
  }

  .radioAll {
    .van-radio {
      line-height: 25px;
      height: 25px;
      font-size: 14px;
    }
  }
  .info {
    color: #4967b7;
    margin: 10px 0;
  }
  .useragent_file {
    padding: 12px 0 20px;
    font-size: 14px;
    span {
      color: #4967b7;
    }
  }
  .dialog_content {
    font-size: 14px;
    letter-spacing: 1px;
  }
  .mt16 {
    margin-top: 16px;
  }
  .mb16 {
    margin-bottom: 16px;
  }
  .btns {
    overflow: hidden;
    .van-button {
      width: 48%;
      border-radius: 7px;
    }
    .submitBtn {
      float: left;
    }
    .resetBtn {
      float: right;
    }
  }
  .radios {
    display: block;
    /deep/.van-field__control--custom {
      display: block;
    }
  }
  .texts {
    display: block;
    /deep/.van-field__control--custom {
      display: block;
    }
  }
}
@media screen and (min-width: 1000px) {
  .home {
    width: 600px;
    margin: 0 auto;
  }
}
</style>
